module.exports = __webpack_public_path__ + "media/images/faces/face26-cf37bf01b1d1b46b42f2e6cb64b72f4a.jpg";